export const ENV = {
  PREVIEW_ENDPOINT: "https://preview.api.play.adapttive.com/preview/",
  PREVIEW_ADD_REFRESH: true,
  CURRENT_ENV: "dev",
};
